(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mm-case-options"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mmCaseOptions) return;
    window.__mmCaseOptions = true;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-mm-case-info-open]');
      if (opener) {
        var dlg = document.getElementById(opener.getAttribute('aria-controls'));
        if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); }
        return;
      }
      var closer = e.target.closest && e.target.closest('[data-mm-case-info-close]');
      if (closer) {
        var d = closer.closest('dialog');
        if (d) d.close();
        return;
      }
      if (e.target instanceof HTMLDialogElement && e.target.hasAttribute('data-mm-case-info')) {
        // Click on the backdrop closes the dialog.
        e.target.close();
        return;
      }

      var link = e.target.closest && e.target.closest('a[data-mm-case]');
      if (!link) return;
      var root = link.closest('[data-mm-cases]');
      if (!root) return;
      try {
        var currentId = new URL(window.location.href).searchParams.get('variant');
        var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (input && input.value) currentId = input.value;
        var cur = JSON.parse(root.getAttribute('data-current') || '[]');
        var sib = JSON.parse(link.getAttribute('data-variants') || '[]');
        var cv = cur.find(function (v) { return String(v.id) === String(currentId); }) || cur[0];
        if (!cv || !sib.length) return;
        var norm = function (a) { return a.map(function (x) { return String(x).toLowerCase().trim(); }); };
        var key = norm(cv.o).join('|');
        var first = norm(cv.o)[0];
        var match = sib.find(function (v) { return norm(v.o).join('|') === key; })
          || sib.find(function (v) { return v.a && norm(v.o).indexOf(first) > -1; })
          || sib.find(function (v) { return norm(v.o).indexOf(first) > -1; });
        if (!match) return;
        e.preventDefault();
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', match.id);
        window.location.href = url.toString();
      } catch (err) { /* fall back to the plain link */ }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mm-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mmDelivery) return;
    window.__mmDelivery = true;

    function addDays(date, n, biz) {
      var d = new Date(date.getTime());
      var left = n;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (!biz || (day !== 0 && day !== 6)) left--;
      }
      return d;
    }
    function fmt(a, b) {
      var am = a.toLocaleDateString('en-US', { month: 'short' });
      var bm = b.toLocaleDateString('en-US', { month: 'short' });
      if (a.toDateString() === b.toDateString()) return am + ' ' + a.getDate();
      if (am === bm && a.getFullYear() === b.getFullYear()) return am + ' ' + a.getDate() + ' – ' + b.getDate();
      return am + ' ' + a.getDate() + ' – ' + bm + ' ' + b.getDate();
    }
    function init(root) {
      if (root.getAttribute('data-mm-ready') === '1') return;
      root.setAttribute('data-mm-ready', '1');
      var n = function (k) { return parseInt(root.getAttribute('data-' + k), 10) || 0; };
      var biz = root.getAttribute('data-biz') === 'true';
      var today = new Date(); today.setHours(12, 0, 0, 0);
      var s1 = addDays(today, n('pmin'), biz), s2 = addDays(today, n('pmax'), biz);
      var d1 = addDays(s1, n('smin'), biz), d2 = addDays(s2, n('smax'), biz);
      var out = { placed: fmt(today, today), ships: fmt(s1, s2), delivered: fmt(d1, d2) };
      root.querySelectorAll('[data-mm-date]').forEach(function (el) {
        var k = el.getAttribute('data-mm-date');
        if (out[k]) el.textContent = out[k];
      });
    }
    function initAll() { document.querySelectorAll('[data-mm-delivery]').forEach(init); }

    document.addEventListener('click', function (e) {
      var t = e.target;
      var open = t.closest && t.closest('[data-mm-delivery-open]');
      if (open) {
        var root = open.closest('[data-mm-delivery]');
        init(root);
        var dlg = root.querySelector('[data-mm-delivery-dialog]');
        if (dlg && dlg.showModal) dlg.showModal();
        return;
      }
      if (t.closest && t.closest('[data-mm-delivery-close]')) {
        var d = t.closest('dialog'); if (d) d.close(); return;
      }
      if (t.matches && t.matches('dialog[data-mm-delivery-dialog]')) t.close();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    new MutationObserver(function () {
      if (document.querySelector('[data-mm-delivery]:not([data-mm-ready="1"])')) initAll();
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mm-more-designs"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mmDesigns) return;
    window.__mmDesigns = true;
    var KEY = 'mmLastCollection';

    function shuffle(a) {
      for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
      return a;
    }
    function store(v) { try { if (v) sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); } catch (e) {} }
    function stored() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
    function collectionFromPath(path) {
      var m = /\/collections\/([^\/?#]+)/.exec(path || '');
      return m && m[1] !== 'all' ? decodeURIComponent(m[1]) : null;
    }
    function contextCollection() {
      var own = collectionFromPath(location.pathname);
      if (own) { store(own); return own; }
      var ref = null;
      try { var r = new URL(document.referrer); if (r.origin === location.origin) ref = r.pathname; } catch (e) {}
      if (ref !== null) {
        var fromRef = collectionFromPath(ref);
        if (fromRef) { store(fromRef); return fromRef; }
        if (/\/products\//.test(ref) || /\/products_preview/.test(ref)) return stored();
        store(null);
        return null;
      }
      return stored();
    }
    function cleanName(title, type) {
      var n = title;
      if (type) {
        n = n.split(type).join('');
        n = n.split(type.replace(/-/g, ' ')).join('');
      }
      n = n.split(' – ')[0].split(' - ')[0].split(' | ')[0].trim();
      return n || title;
    }
    function sized(src) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600'; }
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    /* Animal subgroup from the title, so dog designs show dogs first and cat designs cats first. */
    function animal(title) {
      var t = (title || '').toLowerCase();
      if (/\b(dogs?|pup|puppy|frenchie|dachshund|paw|bone|retriever)\b/.test(t)) return 'dog';
      if (/\b(cats?|kitty|kitten)\b/.test(t)) return 'cat';
      return '';
    }
    function designOf(pr) {
      var opt = (pr.options || []).filter(function (o) { return o.name === 'Design'; })[0];
      return (opt && opt.values && opt.values[0]) || '';
    }
    /* Same animal = 2, same print family = 1; random order within the same score. */
    function rank(list, getDesign, getTitle, curDesign, curAnimal) {
      shuffle(list);
      return list.map(function (x, i) {
        var s = 0;
        if (curDesign && getDesign(x) === curDesign) s += 1;
        if (curAnimal && animal(getTitle(x)) === curAnimal) s += 2;
        return { x: x, s: s, i: i };
      }).sort(function (a, b) { return b.s - a.s || a.i - b.i; }).map(function (o) { return o.x; });
    }

    function localRank(root) {
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 12;
      var track = root.querySelector('[data-mm-designs-track]');
      var items = rank(
        Array.prototype.slice.call(track.children),
        function (el) { return el.getAttribute('data-design') || ''; },
        function (el) { return el.getAttribute('data-title') || ''; },
        root.getAttribute('data-design'),
        animal(root.getAttribute('data-title'))
      );
      items.forEach(function (el, i) { el.hidden = i >= limit; track.appendChild(el); });
      if (items.length) root.classList.add('is-ready');
    }

    function init(root) {
      if (root.getAttribute('data-mm-ready') === '1') return;
      root.setAttribute('data-mm-ready', '1');
      var ctx = contextCollection();
      var def = root.getAttribute('data-default');
      var src = ctx || def;
      if (!src) { localRank(root); return; }
      var fromContext = !!ctx && ctx !== def;

      var type = root.getAttribute('data-type');
      var current = root.getAttribute('data-current');
      var curDesign = root.getAttribute('data-design');
      var curAnimal = animal(root.getAttribute('data-title'));
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 12;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all([
        fetch(base + 'collections/' + encodeURIComponent(src) + '/products.json?limit=250').then(function (r) { return r.ok ? r.json() : { products: [] }; }),
        fromContext
          ? fetch(base + 'collections/' + encodeURIComponent(src) + '.json').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
          : Promise.resolve(null)
      ]).then(function (res) {
        var list = (res[0].products || []).filter(function (pr) { return pr.handle !== current; });
        var same = list.filter(function (pr) { return !type || pr.product_type === type; });
        if (!same.length) { localRank(root); return; }
        same = rank(same, designOf, function (pr) { return pr.title; }, curDesign, curAnimal);
        var html = same.slice(0, limit).map(function (pr) {
          var name = cleanName(pr.title, pr.product_type);
          var img = pr.images && pr.images[0] ? '<img src="' + sized(pr.images[0].src) + '" alt="' + esc(name) + '" loading="lazy">' : '';
          return '<a class="mm-designs__item" href="' + base + 'products/' + pr.handle + '"><span class="mm-designs__img">' + img + '</span><span class="mm-designs__name">' + esc(name) + '</span></a>';
        }).join('');
        root.querySelector('[data-mm-designs-track]').innerHTML = html;
        if (fromContext) {
          var title = res[1] && res[1].collection ? res[1].collection.title : null;
          var tpl = root.getAttribute('data-heading-context');
          if (title && tpl) root.querySelector('[data-mm-designs-heading]').textContent = tpl.replace('[collection]', title);
          var all = root.querySelector('[data-mm-designs-all]');
          if (all) all.setAttribute('href', base + 'collections/' + encodeURIComponent(src));
        }
        root.classList.add('is-ready');
      }).catch(function () { localRank(root); });
    }

    function initAll() { document.querySelectorAll('[data-mm-designs]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    new MutationObserver(function () {
      if (document.querySelector('[data-mm-designs]:not([data-mm-ready="1"])')) initAll();
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
